require('./cardPaymentPurchaseDeferralView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
// @ actions
const cardPaymentPurchaseDeferralActions = require('actions/cardPaymentPurchaseDeferral');
const { getLavandaCards, lavandaReset } = require('actions/lavanda');
const commercialAdsAction = require('actions/commercialInterstitialsAds');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { getChosenDeferralTag, isLavandaCard } = require('utilities/lavandaHelper');
const { recordLink } = require('utilities/tagging');

// @ components
const CardPaymentPurchaseDeferral = require('components/cards/cardPaymentPurchaseDeferral/cardPaymentPurchaseDeferral');
const CardPaymentPurchaseDeferralError = require('components/cards/cardPaymentPurchaseDeferral/cardPaymentPurchaseDeferralError/cardPaymentPurchaseDeferralError');
const CardPaymentPurchaseDeferralFetchError = require('components/cards/cardPaymentPurchaseDeferral/cardPaymentPurchaseDeferralFetchError/cardPaymentPurchaseDeferralFetchError');
const CardPaymentPurchaseDeferralSuccess = require('components/cards/cardPaymentPurchaseDeferral/cardPaymentPurchaseDeferralSuccess/cardPaymentPurchaseDeferralSuccess');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
// @ constants
const { GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');
const { LAVANDA } = require('constants/flagBasedFeatures');
const { FIRST_STEP, SECOND_STEP } = require('constants/index');
const { BACK_TO_CARDS_ACTION_EVENT, SERVICE_ERROR } = require('constants/tagging');

class CardPaymentPurchaseDeferralView extends React.Component {
    constructor(props) {
        super(props);

        this.handleFinish = this.handleFinish.bind(this);
        this.onHandleSetQuotaQuantity = this.onHandleSetQuotaQuantity.bind(this);
        this.setDefaultInstallment = this.setDefaultInstallment.bind(this);
        this.modifyLimit = this.modifyLimit.bind(this);
        this.handleMainButtonClick = this.handleMainButtonClick.bind(this);
    }

    componentWillMount() {
        const { getLavandaCards, lavandaEnabled } = this.props;

        lavandaEnabled && getLavandaCards();
    }

    componentDidMount() {
        const { match: { params: { cardId, movementId } }, history, immCardsTransactions, lavandaEnabled } = this.props;

        if (immCardsTransactions.getIn([cardId, 'byId', movementId])) {
            if (!lavandaEnabled) {
                this.setDefaultInstallment();
            }
        } else {
            history.push(`/myprofile/cards/${cardId}/movements`);
        }
    }

    componentWillReceiveProps(newProps) {
        const {
            fetchSpecificRepayment,
            immCards,
            immCardsTransactions,
            immLavanda,
            lavandaEnabled,
            match: { params: { cardId, movementId } },
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        if (lavandaEnabled && newProps.immLavanda.get('success') && immLavanda.get('isFetching')) {
            if (isLavandaCard(immCard.get('product'), newProps.immLavanda.get('cards'))) {
                fetchSpecificRepayment(cardId, movementId, false);
            } else if (immCardsTransactions.getIn([cardId, 'byId', movementId])) {
                this.setDefaultInstallment()
            }
        }
    }

    componentWillUnmount() {
        this.props.clearRequest();
        this.props.lavandaReset();
    }

    setDefaultInstallment() {
        const {
            fetchRepayment,
            immCardsTransactions,
            match: { params: { cardId, movementId } },
            setDefaultInstallmentQuantity,
        } = this.props;
        const totalAmount = immCardsTransactions.getIn([cardId, 'byId', movementId, 'import', 'amount']);

        setDefaultInstallmentQuantity(totalAmount);
        fetchRepayment(cardId, movementId, false);
    }

    onHandleSetQuotaQuantity(quotaQuantity) {
        const { match: { params: { cardId, movementId } }, setQuotaQuantity } = this.props;

        setQuotaQuantity(quotaQuantity, cardId, movementId);
    }

    modifyLimit() {
        const { match: { params: { cardId } }, history } = this.props;
        const url = `/myprofile/cards/${cardId}/modify-limit`;
        return history.push(url);
    }

    buildBodyContent(immCard, immProfile, immCardPaymentPurchaseDeferral, immMovement) {
        const { immLavanda, lavandaEnabled } = this.props;
        const selectorQuotaStep = lavandaEnabled ? SECOND_STEP : FIRST_STEP;
        const immStep1 = immCardPaymentPurchaseDeferral.getIn(['steps', selectorQuotaStep]);
        const isLavandaFlow = lavandaEnabled && !!immCard && !!immLavanda.get('cards') && isLavandaCard(immCard.get('product'), immLavanda.get('cards'));
        let bodyContent, processDetail, productName;

        if (isLavandaFlow) {
            processDetail = getChosenDeferralTag(immCardPaymentPurchaseDeferral.getIn(['steps', 1, 'installmentQuantity']));
            productName = `${immCard.getIn(['product', 'type'])}.${immCard.getIn(['product', 'subtype'])}`;
        }

        if (immCardPaymentPurchaseDeferral.get('error')) {
            bodyContent = this.buildError(immCard, immProfile, immCardPaymentPurchaseDeferral.get('error'), processDetail, productName);
        } else if (!!immStep1.get('error') || lavandaEnabled && immLavanda.get('error')) {
            bodyContent = this.buildFetchError(immCard, immStep1.get('error') || immLavanda.getIn(['error', 'description']), processDetail, productName);
        } else if (immCardPaymentPurchaseDeferral.get('submitSuccessful')) {
            bodyContent = this.buildSuccess(immCard, immCardPaymentPurchaseDeferral, immMovement, processDetail, productName);
        } else if (!lavandaEnabled || immLavanda.get('success')) {
            bodyContent = this.buildWizard(immCard, immCardPaymentPurchaseDeferral, immMovement);
        } else {
            bodyContent = <LoadingSection />;
        }

        return bodyContent;
    }

    buildBreadcrumb(cardId, alias) {
        return [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: alias,
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('breadcrumb-cardPaymentPurchaseDeferral')
            }
        ];
    }

    buildFetchError(immCard, error, processDetail = '', productName = null) {
        const { lavandaEnabled } = this.props;

        return (
            <CardPaymentPurchaseDeferralFetchError
                categoryError={SERVICE_ERROR}
                descriptionError={lavandaEnabled && error}
                immCard={immCard}
                onMainButtonClick={() => this.handleMainButtonClick(immCard)}
                processDetail={processDetail}
                productName={productName}
            />
        );
    }

    handleMainButtonClick(immCard) {
        const { history, immLavanda, lavandaEnabled } = this.props;
        const isLavandaFlow = lavandaEnabled && isLavandaCard(immCard.get('product'), immLavanda.get('cards'));

        isLavandaFlow && recordLink(window.utag_last_name, BACK_TO_CARDS_ACTION_EVENT);
        history.push(`/myprofile/cards/${immCard.get('cardId')}/movements`);
    }

    buildError(immCard, immProfile, error, processDetail = '', productName = null) {
        const { immLavanda, lavandaEnabled } = this.props;
        const isLavandaFlow = lavandaEnabled && isLavandaCard(immCard.get('product'), immLavanda.get('cards'));

        return (
            <CardPaymentPurchaseDeferralError
                descriptionError={isLavandaFlow && error}
                error={error}
                immCard={immCard}
                immProfile={immProfile}
                modifyLimit={this.modifyLimit}
                onMainButtonClick={() => this.handleMainButtonClick(immCard)}
                processDetail={processDetail}
                productName={productName}
            />
        );
    }

    buildSuccess(immCard, immCardPaymentPurchaseDeferral, immMovement, processDetail = '', productName = null) {
        const { lavandaEnabled } = this.props;

        return (
            <CardPaymentPurchaseDeferralSuccess
                immCard={immCard}
                immCardPaymentPurchaseDeferral={immCardPaymentPurchaseDeferral}
                immMovement={immMovement}
                quotaStep={lavandaEnabled ? SECOND_STEP : FIRST_STEP}
                onMainButtonClick={() => this.handleMainButtonClick(immCard)}
                processDetail={processDetail}
                productName={productName}
            />
        );
    }

    buildWizard(immCard, immCardPaymentPurchaseDeferral, immMovement) {
        const {
            immGlobalVariables,
            immLavanda,
            lavandaEnabled,
            requestAds,
            setDeferralOption,
            setVisibleStep,
            setWillCancel,
            threeMonthQuotaAmount,
            validateStep,
        } = this.props;
        return (
            <CardPaymentPurchaseDeferral
                immCard={immCard}
                immCardPaymentPurchaseDeferral={immCardPaymentPurchaseDeferral}
                immLavanda={immLavanda}
                immMovement={immMovement}
                immGlobalVariables={immGlobalVariables}
                lavandaEnabled={lavandaEnabled}
                setVisibleStep={setVisibleStep}
                setWillCancel={setWillCancel}
                validateStep={validateStep}
                setDeferralOption={setDeferralOption}
                setQuotaQuantity={this.onHandleSetQuotaQuantity}
                onFinish={this.handleFinish}
                threeMonthQuotaAmount={threeMonthQuotaAmount}
                requestAds={requestAds}
            />
        );
    }

    handleFinish() {
        const { match: { params: { cardId, movementId } }, confirmDeferral } = this.props;
        confirmDeferral(cardId, movementId);
    }

    render() {
        const {
            immCardPaymentPurchaseDeferral,
            immCardPaymentPurchaseDeferralLavanda,
            immCards,
            immCardsTransactions,
            immProfile,
            lavandaEnabled,
            match: { params: { cardId, movementId } },
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const immMovement = immCardsTransactions.getIn([cardId, 'byId', movementId]);
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-cardsDeferralPurchaseTitle')}
            />
        );

        let content = <LoadingSection />;
        if (immCard && immMovement) {
            const cardAlias = immCard.getIn(['alias', 'current']);
            const breadcrumb = this.buildBreadcrumb(cardId, cardAlias);
            const cardPaymentPurchaseDeferral = lavandaEnabled ? immCardPaymentPurchaseDeferralLavanda : immCardPaymentPurchaseDeferral;
            const bodyContent = this.buildBodyContent(immCard, immProfile, cardPaymentPurchaseDeferral, immMovement);

            content = (
                <article className="card-payment-purchase-deferral-view">
                    <OKCover size="medium" section="cards">
                        <OKHeaderSubPage
                            breadcrumbConfig={breadcrumb}
                            tutorial={tutorial}
                            finalTitle={getFinalTitle('cardPaymentPurchaseDeferralView-title')}
                        />
                    </OKCover>
                    <section className="card-payment-purchase-deferral-view__body">
                        {bodyContent}
                    </section>
                </article>
            );
        }

        return content;
    }
}

CardPaymentPurchaseDeferralView.propTypes = {
    clearRequest: PropTypes.func.isRequired,
    fetchRepayment: PropTypes.func.isRequired,
    fetchSpecificRepayment: PropTypes.func.isRequired,
    getLavandaCards: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCardPaymentPurchaseDeferral: PropTypes.object.isRequired,
    immCardPaymentPurchaseDeferralLavanda: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardsTransactions: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immLavanda: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    lavandaEnabled: PropTypes.bool,
    lavandaReset: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    requestAds: PropTypes.func.isRequired,
    setDefaultInstallmentQuantity: PropTypes.func.isRequired,
    setDeferralOption: PropTypes.func.isRequired,
    setQuotaQuantity: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    threeMonthQuotaAmount: PropTypes.object,
    confirmDeferral: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired
};

module.exports.constructor = CardPaymentPurchaseDeferralView;
module.exports.CardPaymentPurchaseDeferralView = connect(
    state => ({
        immCardPaymentPurchaseDeferral: state.cardPaymentPurchaseDeferral,
        immCardPaymentPurchaseDeferralLavanda: state.cardPaymentPurchaseDeferralLavanda,
        immCards: state.cards,
        immCardsTransactions: state.cardsTransactions,
        immGlobalVariables: state.globalVariables,
        immLavanda: state.cards.getIn(['credit', 'lavanda']),
        immProfile: state.profile,
        lavandaEnabled: state.flagBasedFeatures.get(LAVANDA),
        threeMonthQuotaAmount: state.cardPaymentPurchaseDeferralLavanda.getIn(['steps', 1, 'specificQuota', 'amount']),
    }), {
    clearRequest: cardPaymentPurchaseDeferralActions.clearRequest,
    fetchRepayment: cardPaymentPurchaseDeferralActions.fetchRepayment,
    fetchSpecificRepayment: cardPaymentPurchaseDeferralActions.fetchSpecificRepayment,
    getLavandaCards,
    lavandaReset,
    requestAds: commercialAdsAction.requestAds,
    setDefaultInstallmentQuantity: cardPaymentPurchaseDeferralActions.setDefaultInstallmentQuantity,
    setDeferralOption: cardPaymentPurchaseDeferralActions.setDeferralOption,
    setQuotaQuantity: cardPaymentPurchaseDeferralActions.setQuotaQuantity,
    setVisibleStep: cardPaymentPurchaseDeferralActions.setVisibleStep,
    setWillCancel: cardPaymentPurchaseDeferralActions.setWillCancel,
    confirmDeferral: cardPaymentPurchaseDeferralActions.confirmDeferral,
    validateStep: cardPaymentPurchaseDeferralActions.validateStep
})(withRouter(CardPaymentPurchaseDeferralView));
